import gsap from 'gsap';
import MorphSVGPlugin from 'gsap/MorphSVGPlugin';
import React, { createRef, useEffect } from 'react';
import styled from 'styled-components';
import { Icon } from '../';
gsap.registerPlugin(MorphSVGPlugin);
const Wrapper = styled.div ``;
export const IconLock = (props) => {
    const wrapperRef = createRef();
    useEffect(() => {
        const dots = wrapperRef.current?.querySelectorAll('path:not(:first-child)');
        if (dots) {
            gsap.to(dots[2], {
                morphSVG: 'M13.75 13C13.75 13.4142 13.4142 13.75 13 13.75C12.5858 13.75 12.25 13.4142 12.25 13C12.25 12.5858 12.5858 12.25 13 12.25C13.4142 12.25 13.75 12.5858 13.75 13Z',
                repeat: -1,
                repeatDelay: 0.6,
                yoyo: true,
                duration: 0.3,
            });
            gsap.to(dots[1], {
                morphSVG: 'M9.25 11.75C9.25 11.3358 9.58579 11 10 11C10.4142 11 10.75 11.3358 10.75 11.75V14.25C10.75 14.6642 10.4142 15 10 15C9.58579 15 9.25 14.6642 9.25 14.25V11.75Z',
                repeat: -1,
                repeatDelay: 0.6,
                delay: 0.6,
                yoyo: true,
                duration: 0.3,
            });
            gsap.to(dots[0], {
                morphSVG: 'M6.25 11.75C6.25 11.3358 6.58579 11 7 11C7.41421 11 7.75 11.3358 7.75 11.75V14.25C7.75 14.6642 7.41421 15 7 15C6.58579 15 6.25 14.6642 6.25 14.25V11.75Z',
                repeat: -1,
                repeatDelay: 0.6,
                delay: 0.3,
                yoyo: true,
                duration: 0.3,
            });
        }
    }, []);
    return (React.createElement(Wrapper, { className: props.className, ref: wrapperRef },
        React.createElement(Icon.Lock, null)));
};
//# sourceMappingURL=Lock.js.map